import CofinsValues from "./cofins-values.enum";

const relations = [
  {
    value: "01",
    options: ["1", "01", "um", "01 - Operação Tributável com Alíquota Básica."]
  },
  {
    value: "02",
    options: [
      "2",
      "02",
      "dois",
      "02 - Operação Tributável com Alíquota Diferenciada."
    ]
  },
  {
    value: "03",
    options: [
      "3",
      "03",
      "três",
      "03 - Operação Tributável com Alíquota por Unidade de Medida de Produto."
    ]
  },
  {
    value: "04",
    options: [
      "4",
      "04",
      "quatro",
      "04 - Operação Tributável Monofásica - Revenda a Alíquota Zero."
    ]
  },
  {
    value: "05",
    options: [
      "5",
      "05",
      "cinco",
      "05 - Operação Tributável por Substituição Tributária."
    ]
  },
  {
    value: "06",
    options: ["6", "06", "seis", "06 - Operação Tributável a Alíquota Zero."]
  },
  {
    value: "07",
    options: ["7", "07", "sete", "07 - Operação Isenta da Contribuição."]
  },
  {
    value: "08",
    options: [
      "8",
      "08",
      "oito",
      "08 - Operação sem Incidência da Contribuição."
    ]
  },
  {
    value: "09",
    options: ["9", "09", "nove", "09 - Operação com Suspensão da Contribuição."]
  }
];

export default raw_unit => {
  const unit = `${raw_unit}`;

  if (CofinsValues[unit]) {
    return CofinsValues[unit].value;
  }

  for (const relation of relations) {
    if (relation && relation.options.includes(unit)) {
      return relation.value;
    }
  }

  return "none";
};



// WEBPACK FOOTER //
// ./src/core/enum/cofins-relationships.enum.js